import BugReportIcon from '@mui/icons-material/BugReport';
import EmailIcon from '@mui/icons-material/Email';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SettingsIcon from '@mui/icons-material/Settings';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Paper, Typography } from '@mui/material';
import { useState } from 'react';
import AdminPageWrapper from './AdminPageWrapper';
import EmailDomainMigrationTool from './DomainMigration';
import PathValidationTool from './PathValidationTool';

const OpsToolDashboard = ({ darkMode, toggleDarkMode, themeVariant }) => {
    const [expanded, setExpanded] = useState(false);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <AdminPageWrapper
            title="Operations Tools"
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            themeVariant={themeVariant}
        >
            <Box display="flex" alignItems="center" mb={3}>
                <SettingsIcon sx={{ fontSize: 30, mr: 2, color: 'info.main' }} />
                <Typography variant="h4">Operations Tools</Typography>
            </Box>

            <Typography variant="body1" paragraph>
                This dashboard provides access to administrative operations tools for database management, migrations,
                and other system maintenance tasks.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Paper sx={{ mb: 4 }}>
                {/* Email Domain Migration Accordion */}
                <Accordion
                    expanded={expanded === 'emailDomainMigration'}
                    onChange={handleAccordionChange('emailDomainMigration')}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="email-domain-migration-content"
                        id="email-domain-migration-header"
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <EmailIcon sx={{ mr: 2, color: 'secondary.main' }} />
                            <Typography variant="h6">Email Domain Migration</Typography>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ p: 2 }}>
                            <Typography variant="body2" sx={{ mb: 3 }}>
                                Migrate email domains across the database (e.g., @vaani.org to @amrutvaani.org). Updates
                                user records, videos, groups, and history.
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            {/* Import and render your EmailDomainMigrationTool component here */}
                            <EmailDomainMigrationTool darkMode={darkMode} themeVariant={themeVariant} />
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {/* Path Validation Accordion */}
                <Accordion
                    expanded={expanded === 'pathValidation'}
                    onChange={handleAccordionChange('pathValidation')}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="path-validation-content"
                        id="path-validation-header"
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <BugReportIcon sx={{ mr: 2, color: 'warning.main' }} />
                            <Typography variant="h6">Path Validation & Fix</Typography>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ p: 2 }}>
                            <Typography variant="body2" sx={{ mb: 3 }}>
                                Validate and fix MongoDB filesystem node paths. Identifies mismatches between
                                stored paths and calculated paths based on parent hierarchy.
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            <PathValidationTool darkMode={darkMode} themeVariant={themeVariant} />
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Paper>
        </AdminPageWrapper>
    );
};

export default OpsToolDashboard;
